import { Fragment } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import { breadcrumbTrail } from '@/lib/breadcrumbs'
import { useBreadcrumbLeaf, useBreadcrumbTrailOverride } from '@/hooks/useBreadcrumb'
import { cn } from '@/lib/utils'

export function Breadcrumbs() {
  const { pathname } = useLocation()
  const leaf = useBreadcrumbLeaf()
  const override = useBreadcrumbTrailOverride()
  const trail = override ?? breadcrumbTrail(pathname)

  if (trail.length === 0) return <div className="min-w-0 flex-1" />

  const crumbs = leaf ? [...trail, { label: leaf }] : trail

  return (
    <nav aria-label="Navegação estrutural" className="flex min-w-0 flex-1 items-center gap-1.5 overflow-hidden text-sm text-muted-foreground">
      {crumbs.map((crumb, index) => {
        const last = index === crumbs.length - 1
        return (
          <Fragment key={`${index}-${crumb.label}`}>
            {index > 0 && <ChevronRight className="hidden h-3.5 w-3.5 shrink-0 text-muted-foreground/60 sm:block" aria-hidden />}
            {crumb.to && crumb.to !== pathname ? (
              <Link to={crumb.to} className={cn('shrink-0 whitespace-nowrap transition-colors hover:text-foreground', !last && 'hidden sm:inline')}>
                {crumb.label}
              </Link>
            ) : (
              <span
                aria-current={last ? 'page' : undefined}
                className={cn(last ? 'truncate font-medium text-foreground' : 'hidden shrink-0 whitespace-nowrap sm:inline')}
              >
                {crumb.label}
              </span>
            )}
          </Fragment>
        )
      })}
    </nav>
  )
}
